import { render, staticRenderFns } from "./SiPi.vue?vue&type=template&id=5b6fd73c&scoped=true&lang=html&"
import script from "./SiPi.vue?vue&type=script&lang=js&"
export * from "./SiPi.vue?vue&type=script&lang=js&"
import style0 from "./SiPi.vue?vue&type=style&index=0&id=5b6fd73c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6fd73c",
  null
  
)

export default component.exports